export const isStringValue = (value: unknown): value is string =>
    typeof value === "string";